import { Button, DangerIcon, Field, Select as ReactSelect, selectedItemLabel, TruncateText } from '@panwds/react-ui';
import { classNames } from '@panwds/tailwindcss';
import React, { useMemo } from 'react';
import { get, useController, useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { v4 as uuidV4 } from 'uuid';
import { requiredMessage } from '../../messages.js';
/**
 * Renders a select connected to the form. All extra props will get passed to the select.
 */
export const Select = (props) => {
    const intl = useIntl();
    const { size = 'md', name, label, register = {}, defaultValue = null, description, tooltip, disabled, showLabel, addButtonClassName, simpleFormat = false, placeholder = intl.formatMessage({
        defaultMessage: 'Placeholder Text...',
        id: 'SCclC5',
        description: 'Placeholder text value for select button'
    }), requiredAsterisk, ...rest } = props;
    const labelId = useMemo(() => `field-${uuidV4()}-label`, []);
    const buttonId = useMemo(() => `field-${uuidV4()}-button`, []);
    const context = useFormContext();
    /* istanbul ignore next */
    if (context === null) {
        throw new Error('Attempted to render Select outside of a Form context. Make sure your component is rendered inside <Form>.');
    }
    const { formState } = context;
    register.required =
        register.required === false
            ? register.required
            : intl.formatMessage(requiredMessage, {
                label
            });
    const { field: { onChange, ref, value } } = useController({
        name,
        defaultValue: defaultValue,
        rules: disabled ? {} : register
    });
    const valueMap = useMemo(() => simpleFormat && !!rest.items
        ? rest.items.reduce((acc, curr) => {
            acc[`${curr.value}`] = curr;
            return acc;
        }, {})
        : {}, [rest.items, simpleFormat]);
    const selected = useMemo(() => {
        if (simpleFormat) {
            return rest.enableMultiSelect ? value?.map((value) => valueMap[value] ?? { value }) : value && { value };
        }
        return value;
    }, [value, simpleFormat]);
    const hasError = formState.errors[name];
    const DefaultButton = (React.createElement(Button, { addClassName: classNames('twds-flex-auto twds-text-left twds-bg-white dark:twds-bg-black twds-bg-opacity-80 dark:twds-bg-opacity-16', hasError &&
            'twds-border-red-500 dark:twds-border-red-500 hover:twds-border-red-500 dark:hover:-twds-border-red-500', addButtonClassName), onClick: (e) => e.stopPropagation(), size: size, fullWidth: true, isMenu: true, isSelected: (selected && selected.length > 0) || (selected && selected.value !== ''), buttonType: "form-select" },
        React.createElement(TruncateText, { addClassName: classNames('twds-flex-auto twds-text-left', hasError ? 'twds-pr-0 twds-mr-2' : 'twds-pr-6') }, selectedItemLabel(selected) || placeholder),
        hasError && React.createElement(DangerIcon, { size: "lg" })));
    return (React.createElement(Field, { label: label, labelId: labelId, optional: !register.required, control: React.createElement(ReactSelect, { button: DefaultButton, fullWidth: true, ...rest, buttonRef: ref, labelId: labelId, toggleButtonId: buttonId, disabled: disabled, selectedItem: selected, onChange: (changes) => simpleFormat
                ? onChange(rest.enableMultiSelect ? changes.selectedItems.map((item) => item.value) : changes.selectedItem.value)
                : onChange(rest.enableMultiSelect ? changes.selectedItems : changes.selectedItem) }), error: get(formState.errors, name)?.message, description: description, tooltip: tooltip, disabled: disabled, showLabel: showLabel, requiredAsterisk: requiredAsterisk }));
};
//# sourceMappingURL=Select.js.map